import { routesMap } from '../../../../routes/AppRoutes';
import HeroSection from '../../../conduct-risk/HeroSection';

interface DataFromParent {
  name: string | undefined;
  title: string | undefined;
  reportId?: string;
}

const BannerCalcoloRanking = ({ name, reportId }: DataFromParent) => {
  return (
    <HeroSection
      title="Ranking"
      description={`Calcolo del ranking per ${name ?? ''}`}
      breadcrumbLinks={[
        { url: routesMap.HOME_PAGE, title: 'Home' },
        { url: routesMap.BEST_EXECUTION_HOME, title: 'Best Execution' },
        { url: routesMap.REPORT_PAGE, title: 'Report' },
        { url: routesMap.VISUALIZZA_REPORT(name ?? ''), title: name ?? '', state: { id: reportId } },
        { url: '#', title: 'Ranking' },
      ]}
    />
  );
};

export default BannerCalcoloRanking;
